/**
 * Interfaces LKP (Lookup) para plano de aula
 */

export type ListaLKPTurma = LKPTurma[];

export interface LKPTurma {
  CDESCOLA: number;
  ANO: number;
  CPF: string;
  ID_TURMA: number;
  CDCURSO: number;
  CURSO: string;
  CDTUR: number;
  TURNO: string;
  CDSERIE: number;
  SERIE: string;
  CDTURMA: string;
  ETAPA_BNCC: number;
  FAIXAETARIA: string;
  ATIVO: number;
  INTERVALOAVALIACAO: number;
}

export type ListaLKPPeriodo = LKPPeriodo[];

export interface LKPPeriodo {
  IDPERIODO: number;
  PERIODO: string;
}

export type ListaLKPDisciplinas = LKPDisciplinas[];

export interface LKPDisciplinas {
  CDESCOLA: number;
  SEQUENCIAL: number;
  CDPROF: string;
  ID_TURMA: number;
  CDDISC: number;
  BIMESTRE: number;
  PROFESSOR: string;
  CURSO: string;
  TURNO: string;
  SERIE: string;
  DISCIPLINA: string;
  STATUS: string;
  EXPORTADO: string;
  SERIETURMA: string;
  CDTURMA: string;
  IDANOETAPA: string;
  IDAREACOMPONENTE: string;
  GRUPO: string;
  ETAPA_BNCC: string;
  CDTPDISC: number;
  TIPODISCIPLINA: string;
  MULTI: number;
  ETAPA_BNCC_SERIE: number;
  COLUNA_ACAO: string;
}

export type ListaLKPIntervalo = LKPIntervalo[];

export interface LKPAtividades {
  CDATIVIDADE: number;
  DSATIVIDADE: string;
  OBSERVACOES?: string;
}

export type ListaLKPAtividades = LKPAtividades[];

export interface LKPPlanoAulaRecurso {
  ID_RECURSO: number;
  RECURSO: string;
}

export type ListaLKPPlanoAulaRecurso = LKPPlanoAulaRecurso[];

export interface LKPIntervalo {
  ID_INTERVALO: number;
  INTERVALO: string;
}

/**
 * Request para buscar turmas LKP
 */
export interface GetLKPTurmaRequest {
  ANO: number;
  CDESCOLA: number;
  CPF: string;
  PERIODO: number;
  INCLUSAO: number;
  DATABASE: string;
  CPF_COORDENADOR?: string;
  CDSERIE?: number;
  EXERC?: number;
}

/**
 * Request para buscar períodos LKP
 */
export interface GetLKPPeriodoRequest {
  CDESCOLA: number;
  ID_TURMA: number;
  ANO: number;
  DATABASE: string;
}

/**
 * Request para buscar disciplinas LKP
 */
export interface GetLKPDisciplinasRequest {
  ID_TURMA: number;
  BIMESTRE: number;
  ANO: number;
  CDESCOLA: number;
  CPF: string;
  DATABASE: string;
}

/**
 * Request para buscar intervalo LKP
 */
export interface GetLKPIntervaloRequest {
  INTERVALOAVALIACAO: number;
  DATABASE: string;
}
